import { ActionType } from 'typesafe-actions'
import {
  EARLIEST_RATING_SET,
  RATING_HISTORY_DATE_RANGE_SET,
  RATING_HISTORY_REQUESTED,
  RATING_HISTORY_COMPLETED,
  RATING_HISTORY_REQUEST_FAILED,
} from 'actions/ratings-actions'
import * as actions from 'actions/ratings-actions'
import { RatingHistory } from 'types/global'
import { RATING_HISTORY_START_DEFAULT } from 'constants/profile'

type RatingsAction = ActionType<typeof actions>

type State = Readonly<{
  loadingRatings: boolean
  errorRatings: Error | null
  ratings: RatingHistory[]
  earliestRecord: string
  wtnChartRange: {
    start: string
    end: string
  }
}>

const initialState: State = {
  loadingRatings: false,
  errorRatings: null,
  ratings: [],
  earliestRecord: '',
  wtnChartRange: {
    start: new Date(RATING_HISTORY_START_DEFAULT).toISOString(),
    end: new Date().toISOString(),
  },
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state: State = initialState, action: RatingsAction): State {
  switch (action.type) {
    case RATING_HISTORY_REQUESTED:
      return { ...state, loadingRatings: true, errorRatings: null }
    case RATING_HISTORY_COMPLETED:
      return { ...state, loadingRatings: false, ratings: action.payload }
    case RATING_HISTORY_REQUEST_FAILED:
      return { ...state, loadingRatings: false, errorRatings: action.payload }
    case EARLIEST_RATING_SET:
      return { ...state, earliestRecord: action.payload }
    case RATING_HISTORY_DATE_RANGE_SET:
      return { ...state, wtnChartRange: action.payload }
    default:
      return state
  }
}
